import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';

export const summaryRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/summaries/$id',
  component: Summary,
});

function Summary() {
  const { id } = summaryRoute.useParams();
  return (
    <section>
      <h1 style={{ marginTop: 0 }}>Summary {id}</h1>
      <p style={{ color: '#666' }}>
        Real summary view (decrypts an encrypted blob client-side per ADR-019) lands in WEB-101.
      </p>
    </section>
  );
}
